import { render, staticRenderFns } from "./PropColumn.vue?vue&type=template&id=37640f28"
import script from "./PropColumn.vue?vue&type=script&lang=js"
export * from "./PropColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports